import {ProductSelectionOption} from "@/data/entities/cart";
import React from "react";
import {InformationCircleIcon} from "@heroicons/react/16/solid";
import {formatMoney} from "@/utils/MoneyUtils";
import {FormattedMessage} from "react-intl";

type Props = {
    option: ProductSelectionOption,
    isAvailable: boolean,
};

const DepositIndicator = ({option, isAvailable}: Props) => {
    if (option.soldout
        || !isAvailable
        || Number(option.deposit) === 0) {
        return <></>
    }

    return (
        <small
            className={"text-eat-xs flex flex-row items-center justify-start gap-1 text-gray-600 fill-gray-500 dark:text-gray-400 dark:fill-gray-300"}
        >
            <InformationCircleIcon className={"size-3 shrink-0"}/>

            <FormattedMessage
                id={"ex-deposit"}
                values={{
                    price: formatMoney(Number(option.deposit))
                }}
            />
        </small>
    );
};

export default DepositIndicator;